import { Component, Story, Knobs } from './DocTypes';

const PlaygroundStoryKnobs: Knobs = {
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const playgroundStory: Story = {
  title: 'Playground',
  description: 'A simple list',
  coreComponent_v3: {
    html: `
     <tag3-simple-list {{...knobs}}>
      <tag3-list-item item-id="0">
        <div slot="left" style="display: flex; align-items: center;">
          <tag3-icon icon="Badge2" accent="atoll"></tag3-icon>
          <tag3-p text-style='{"font-size": "15px", "font-weight": "700", "margin": "0 10px", "padding": "2px 0 0"}' inline>Jordan Pickford</tag3-p>
        </div>
        <div slot="right" style="margin: 0 10px;">
          <tag3-p text-style='{"color": "#7d7d80", "line-height": "18px"}'>
            Date of Birth: 
            <tag3-format data-type='date' text='1994-04-09T00:00:00.000Z' text-style='{"padding-left": "4px"}'></tag3-format>     
          </tag3-p>
        </div>
      </tag3-list-item>

      <tag3-list-item item-id="1">
        <div slot="left" style="display: flex; align-items: center;">
          <tag3-icon icon="Badge2" accent="atoll"></tag3-icon>
          <tag3-p text-style='{"font-size": "15px", "font-weight": "700", "margin": "0 10px", "padding": "2px 0 0"}' inline>Kyle Walker</tag3-p>
        </div>
        <div slot="right" style="margin: 0 10px;">
          <tag3-p text-style='{"color": "#7d7d80", "line-height": "18px"}'>
            Date of Birth: 
            <tag3-format data-type='date' text='1978-03-04T00:00:00.000Z' text-style='{"padding-left": "4px"}'></tag3-format>     
          </tag3-p>
        </div>
      </tag3-list-item>

      <tag3-list-item item-id="2">
        <div slot="left" style="display: flex; align-items: center;">
          <tag3-icon icon="Badge2" accent="atoll"></tag3-icon>
          <tag3-p text-style='{"font-size": "15px", "font-weight": "700", "margin": "0 10px", "padding": "2px 0 0"}' inline>John Stones</tag3-p>
        </div>
        <div slot="right" style="margin: 0 10px;">
          <tag3-p text-style='{"color": "#7d7d80", "line-height": "18px"}'>
            Date of Birth: 
            <tag3-format data-type='date' text='1990-01-01T00:00:00.000Z' text-style='{"padding-left": "4px"}'></tag3-format>     
          </tag3-p>
        </div>
      </tag3-list-item>

      <tag3-list-item item-id="3">
        <div slot="left" style="display: flex; align-items: center;">
          <tag3-icon icon="Badge2" accent="atoll"></tag3-icon>
          <tag3-p text-style='{"font-size": "15px", "font-weight": "700", "margin": "0 10px", "padding": "2px 0 0"}' inline>Harry Maguire</tag3-p>
        </div>
        <div slot="right" style="margin: 0 10px;">
          <tag3-p text-style='{"color": "#7d7d80", "line-height": "18px"}'>
            Date of Birth: 
            <tag3-format data-type='date' text='1998-01-19T00:00:00.000Z' text-style='{"padding-left": "4px"}'></tag3-format>     
          </tag3-p>
        </div>
      </tag3-list-item>

     </tag3-simple-list>
    `,
    knobs: PlaygroundStoryKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
      const data=[
        { name: 'Jordan Pickford', dob: '1994-04-09T00:00:00.000Z' },
        { name: 'Kyle Walker', dob: '1978-03-04T00:00:00.000Z' },
        { name: 'John Stones', dob: '1990-01-01T00:00:00.000Z' },
        { name: 'Harry Maguire', dob: '1998-01-19T00:00:00.000Z' },
      ];
      return (
        <Tag3SimpleList {{...knobs}}>
          {data.map((d,i) => (
            <Tag3ListItem key={i} itemId={i}>
              <div slot="left" style={{display: "flex", alignItems: "center"}}>
                <Tag3Icon icon="Badge2" accent="atoll" />
                <Tag3Text type="p" textStyle={{fontSize: "15px", fontWeight: "700", margin: "0 10px", padding: "2px 0 0"}} inline>
                  {d.name}
                </Tag3Text>
              </div>

              <div slot="right" style={{margin: "0 10px"}}>
                <Tag3Text type="p" textStyle={{color: "#7d7d80", lineHeight: "18px"}}>
                  Date of Birth: 
                  <Tag3Format dataType='date' text={d.dob} textStyle={{paddingLeft: "4px"}}></Tag3Format>     
                </Tag3Text>
              </div>
            </Tag3ListItem>
          ))}
        </Tag3SimpleList>
      );
    }
    `,
    knobs: PlaygroundStoryKnobs,
  },
};

const buttonsStory: Story = {
  title: 'Buttons',
  description: 'A simple list having buttons',
  coreComponent_v3: {
    html: `
    <tag3-simple-list>
      <tag3-list-item item-id="0">
        <div slot="left" style="display: flex; align-items: center;">
          <img src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260"
            style="border-radius: 50%; height: 40px; object-fit: cover; width: 40px; margin-right: 10px" />
          <tag3-text text-style='{"font-size": "15px", "font-weight": "700", "padding": "2px 0 0", "display": "inline"}'>Jordan Norry</tag3-text>
        </div>
        <div slot="right" style="margin: 0 10px;">
          <tag3-button button-style='{"margin-right": "10px"}'>Edit</tag3-button>
          <tag3-button>View</tag3-button> 
        </div>
      </tag3-list-item>

      <tag3-list-item item-id="1">
        <div slot="left" style="display: flex; align-items: center;">
          <img src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260"
            style="border-radius: 50%; height: 40px; object-fit: cover; width: 40px; margin-right: 10px" />
          <tag3-text text-style='{"font-size": "15px", "font-weight": "700", "padding": "2px 0 0", "display": "inline"}'>Sarah Young</tag3-text>
        </div>
        <div slot="right" style="margin: 0 10px;">
          <tag3-button button-style='{"margin-right": "10px"}'>Edit</tag3-button>
          <tag3-button>View</tag3-button> 
        </div>
      </tag3-list-item>
    </tag3-simple-list>`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
      const data=[
        {
          image:
            'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          name: 'Jordan Norry',
        },
        {
          image:
            'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          name: 'Sarah Young',
        }
      ];
      return (
        <Tag3SimpleList>
          {data.map((d,i) => (
            <Tag3ListItem key={i} itemId={i}>
              <div slot="left" style={{display: "flex", alignItems: "center"}}>
                <img src={d.image} style={{borderRadius: "50%", height: "40px", objectFit: "cover", width: "40px", marginRight: "10px"}} />
                <Tag3Text type="p" textStyle={{fontSize: "15px", fontWeight: "700", display: "inline", padding: "2px 0 0"}}>
                  {d.name}
                </Tag3Text>
              </div>

              <div slot="right" style={{margin: "0 10px"}}>
                <Tag3Button text='Edit' buttonStyle={{marginRight: "15px"}}/>
                <Tag3Button text='View'/>
              </div>
            </Tag3ListItem>
          ))}
        </Tag3SimpleList>
      );
    }
    `,
  },
};

export const selectableStory: Story = {
  title: 'Selectable',
  description: 'List with selectable items',
  coreComponent_v3: {
    html: `
      <tag3-simple-list selectable>
        <tag3-list-item data="0">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Harry Maguire</tag3-text>
          </div>
        </tag3-list-item>

        <tag3-list-item data="1">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Luke Shaw</tag3-text>
          </div>
        </tag3-list-item>
  
        <tag3-list-item data="2">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Mason Mount</tag3-text>
          </div>
        </tag3-list-item>
  
        <tag3-list-item data="3">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Phil Foden</tag3-text>
          </div>
        </tag3-list-item>
      </tag3-simple-list>
      `,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
        const data=[
          { name: 'Harry Maguire', id: "0" },
          { name: 'Luke Shaw', id: "1" },
          { name: 'Mason Mount', id: "2" },
          { name: 'Phil Foden', id: "3" },
        ];
        return (
          <Tag3SimpleList selectable>
            {data.map((d,i) => (
              <Tag3ListItem itemId={d.id} key={i}>
                <div slot="left" style={{margin: "0 10px", display: "flex", alignItems: "center"}}>
                  <Tag3Text type="p" textStyle={{fontSize: "15px", fontWeight: "700"}}>
                    {d.name}
                  </Tag3Text>
                </div>
              </Tag3ListItem>
            ))}
          </Tag3SimpleList>
        );
      }
      `,
  },
};

export const selectableWithDefaultStory: Story = {
  title: 'Selectable with default',
  description: 'List with selectable items with an item selected as default',
  coreComponent_v3: {
    html: `
      <tag3-simple-list selectable selected-item="1">
        <tag3-list-item data="0">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Harry Maguire</tag3-text>
          </div>
        </tag3-list-item>

        <tag3-list-item data="1">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Luke Shaw</tag3-text>
          </div>
        </tag3-list-item>
  
        <tag3-list-item data="2">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Mason Mount</tag3-text>
          </div>
        </tag3-list-item>
  
        <tag3-list-item data="3">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Phil Foden</tag3-text>
          </div>
        </tag3-list-item>
      </tag3-simple-list>
      `,
  },
};

export const listItemClickedStory: Story = {
  title: 'List Item Clicked',
  description: 'List item Clicked',
  coreComponent_v3: {
    html: `
      <tag3-simple-list>
        <tag3-list-item item-id="0">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Harry Maguire</tag3-text>
          </div>
        </tag3-list-item>
  
        <tag3-list-item item-id="1">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Luke Shaw</tag3-text>
          </div>
        </tag3-list-item>
  
        <tag3-list-item item-id="2">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Mason Mount</tag3-text>
          </div>
        </tag3-list-item>
  
        <tag3-list-item item-id="3">
          <div slot="left" style="margin: 0 10px; display: flex; align-items: center;">
            <tag3-text text-style='{"font-size": "15px", "font-weight": "700"}'>Phil Foden</tag3-text>
          </div>
        </tag3-list-item>
      </tag3-simple-list>
      `,
    js: `var tagList = document.querySelector('tag3-simple-list');
    tagList.componentOnReady().then(function() {
      tagList.addEventListener('listItemClicked', function(e) {
        console.log('Item with id ' + e.detail.id + ' has been clicked!');
      });
    });
      `,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
        const data=[
          { name: 'Harry Maguire', id: "0" },
          { name: 'Luke Shaw', id: "1" },
          { name: 'Mason Mount', id: "2" },
          { name: 'Phil Foden', id: "3" },
        ];
        return (
          <Tag3SimpleList>
            {data.map((d,i) => (
              <Tag3ListItem itemId={d.id} key={i} onListItemClicked={e => console.log('Item with id', e.detail.id, 'has been clicked!')}>
                <div slot="left" style={{margin: "0 10px", display: "flex", alignItems: "center"}}>
                  <Tag3Text type="p" textStyle={{fontSize: "15px", fontWeight: "700"}}>
                    {d.name}
                  </Tag3Text>
                </div>
              </Tag3ListItem>
            ))}
          </Tag3SimpleList>
        );
      }
      `,
  },
};

export const TagSimpleListDocs: Component = {
  type: 'component',
  name: 'simple-list',
  description: 'Renders a simple list',
  mobileFriendly: false,
  preRelease: 'alpha',
  popular: false,
  props: [
    // Commented as not currently supported
    // {
    //   name: 'selectable',
    //   description:
    //     'Whether items in the list can be selected and allow the listItemSelected event to be raised',
    //   type: 'boolean',
    // },
    {
      name: 'colour-scheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  methods: [],
  events: [
    // Commented as not currently supported
    // {
    //   name: 'listItemSelected',
    //   description: 'Raised when a list item is selected',
    //   parameters: [
    //     {
    //       name: 'data',
    //       description: 'The data item behind the selected list item',
    //       type: 'any',
    //     },
    //   ],
    // },
    // {
    //   name: 'listItemClicked',
    //   description: 'Raised when a list item is clicked',
    //   parameters: [
    //     {
    //       name: 'data',
    //       description: 'The data item behind the clicked list item',
    //       type: 'any',
    //     },
    //   ],
    // },
  ],
  stories: [
    playgroundStory,
    buttonsStory,
    // Commented as not currently valid demos
    // selectableStory,
    // selectableWithDefaultStory,
    // listItemClickedStory,
  ],
};
